import { render, staticRenderFns } from "./ChekYourEmail.vue?vue&type=template&id=30cdaffc&scoped=true&"
import script from "./ChekYourEmail.vue?vue&type=script&lang=js&"
export * from "./ChekYourEmail.vue?vue&type=script&lang=js&"
import style0 from "./ChekYourEmail.vue?vue&type=style&index=0&id=30cdaffc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cdaffc",
  null
  
)

export default component.exports